export interface AuroraDesktopBridge {
  platform: string;
  version: string;
  proxyUrl: (targetUrl: string) => string;
}

declare global {
  interface Window {
    auroraDesktop?: AuroraDesktopBridge;
  }
}

export function isAuroraDesktop(): boolean {
  return typeof window !== 'undefined' && typeof window.auroraDesktop?.proxyUrl === 'function';
}

export function desktopProxyUrl(targetUrl: string): string {
  if (!isAuroraDesktop() || !/^https?:\/\//i.test(targetUrl)) return targetUrl;
  return window.auroraDesktop!.proxyUrl(targetUrl);
}
